export default function LoadingSpinner({ size = 32, color = '#000666', fullPage = false }) {
  const spinner = (
    <div
      className="rounded-full border-4"
      style={{
        width: size,
        height: size,
        borderColor: `${color}30`,
        borderTopColor: color,
        animation: 'spin 0.7s linear infinite',
      }}
    />
  )

  if (fullPage) {
    return (
      <div className="flex items-center justify-center flex-1 py-20">
        {spinner}
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    )
  }

  return (
    <>
      {spinner}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </>
  )
}
